export const formModel = ({ intl }) => ({
  id: "contact-info",
  fields: {
    paymentDestination: {
      name: "paymentDestination",
    },
    concept: {
      name: "concept",
      label: intl.formatMessage({
        id: "common.concept",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
    },
    amount: {
      name: "amount",
      label: intl.formatMessage({
        id: "common.amount",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
    },
    email: {
      name: "email",
      label: intl.formatMessage({
        id: "common.email",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
      invalidErrorMsg: intl.formatMessage({
        id: "common.invalidEmail",
      }),
    },
    validity: {
      name: "validity",
      label: intl.formatMessage({
        id: "common.validity",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
    },
    referenceNumeric: {
      name: "reference",
      label: intl.formatMessage({
        id: "common.numericReference",
      }),
      placeholder: intl.formatMessage({
        id: "cashPayment.createBallot.cieKeys.withValidity.inputPlaceholder",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
    },
    referenceAlphanumeric: {
      name: "reference",
      label: intl.formatMessage({
        id: "common.alphanumericReference",
      }),
      placeholder: intl.formatMessage({
        id: "cashPayment.createBallot.cieKeys.custom.inputPlaceholder",
      }),
      requiredErrorMsg: intl.formatMessage({
        id: "common.requiredField",
      }),
    },
  },
});
